import React from 'react';
import { Dialog, IconButton } from '@mui/material';
import styled from 'styled-components';
import CloseIcon from '@mui/icons-material/Close';
import ButtonComponent from '../buttton';

const ModalContainer = styled(Dialog)`
  .MuiDialog-paper {
    padding: 32px 24px;
    border-radius: 16px;
    max-width: 420px;
    width: 100%;
  }
`;

const Title = styled.h2`
  font-family: 'Urbanist';
  font-size: 24px;
  font-weight: 600;
  color:"#000000";
  text-align: center;
  margin-bottom: 8px;
`;

const Description = styled.p`
  font-size: 14px;
  text-align: center;
  color: #404040;
  font-family: 'Urbanist';
  margin-bottom: 24px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const ConfirmApproveModal = ({ open, onClose, onConfirm, loader }) => (
  <ModalContainer open={open} onClose={onClose}>
    <IconButton onClick={onClose} style={{ position: 'absolute', top: 8, right: 8 }}>
      <CloseIcon />
    </IconButton>
    <Title>Are You Sure You Want <br />to Approve This <br />Recommendation?</Title>
    <Description>
      This action will add the boss and the recommendation<br/> on the platform. The boss and employee will be <br/>notified.
    </Description>
    <ButtonWrapper>
      <ButtonComponent name="Approve" onClick={onConfirm} styles={{ backgroundColor: "#12188A" }} loader={loader} />
    </ButtonWrapper>
  </ModalContainer>
);

export default ConfirmApproveModal;
